import React from 'react'
import { Link } from 'react-router-dom'
import { PlusIcon, BriefcaseIcon } from '@heroicons/react/24/outline'

export default function QuickActions() {
  return (
    <div className='card'>
      <div className='card-header'>
        <h3 className='text-lg leading-6 font-medium text-gray-900 dark:text-gray-300'>
          Quick Actions
        </h3>
      </div>
      <div className='card-body'>
        <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3'>
          <Link
            to='/jobs/create'
            className='relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-blue-500 rounded-lg border border-gray-200 hover:border-blue-500 dark:bg-gray-200 dark:border-blue-500 dark:border-2'
          >
            <div>
              <span className='rounded-lg inline-flex p-3 bg-blue-50 text-blue-700 ring-4 ring-white'>
                <PlusIcon className='h-6 w-6' />
              </span>
            </div>
            <div className='mt-4'>
              <h3 className='text-lg font-medium'>
                <span className='absolute inset-0' />
                Create New Job
              </h3>
              <p className='mt-2 text-sm text-gray-500'>
                Start a new scraping job for a specific state
              </p>
            </div>
          </Link>

          <Link
            to='/stores'
            className='relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-green-500 rounded-lg border border-gray-200 hover:border-green-500 dark:bg-gray-200 dark:border-blue-500 dark:hover:border-red-500'
          >
            <div>
              <span className='rounded-lg inline-flex p-3 bg-green-50 text-green-700 ring-4 ring-white'>
                <BriefcaseIcon className='h-6 w-6' />
              </span>
            </div>
            <div className='mt-4'>
              <h3 className='text-lg font-medium'>
                <span className='absolute inset-0' />
                View Stores
              </h3>
              <p className='mt-2 text-sm text-gray-500'>
                Browse and filter scraped store data
              </p>
            </div>
          </Link>

          <Link
            to='/export'
            className='relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-purple-500 rounded-lg border border-gray-200 hover:border-gray-500 dark:bg-gray-200 dark:border-blue-500 dark:hover:border-red-500'
          >
            <div>
              <span className='rounded-lg inline-flex p-3 bg-purple-50 text-purple-700 ring-4 ring-white'>
                <svg
                  className='h-6 w-6'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
                  />
                </svg>
              </span>
            </div>
            <div className='mt-4'>
              <h3 className='text-lg font-medium'>
                <span className='absolute inset-0' />
                Export Data
              </h3>
              <p className='mt-2 text-sm text-gray-500'>
                Export stores to CSV, Excel, or Zoho CRM
              </p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}





